import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "padding": "16px",
    "font-size": "14px !important",
    "background-color": "white"
  }
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1);
}